import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PortfolioGraphic from '../assets/images/portfolio.jpg';

function Portfolio() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('opacity-0', 'translate-y-12');
            entry.target.classList.add('opacity-100', 'translate-y-0');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    const hiddenElements = document.querySelectorAll('.animate-on-scroll');
    hiddenElements.forEach((el) => observer.observe(el));

    return () => {
      hiddenElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  const projects = [
    { 
      title: "VentureConnect", 
      desc: "Architected a dynamic travel social media application designed to seamlessly connect users with travel buddies, localized events, and curated industry deals." 
    },
    { 
      title: "Lush Lab", 
      desc: "Engineered a high-performance e-commerce storefront featuring secure transaction gateways, optimized user flow, and scalable product management infrastructure." 
    },
    { 
      title: "Municipal Enterprise Architecture", 
      desc: "Oversaw ICT strategy and digital transformation for a public sector entity, aligning complex municipal data frameworks with scalable, secure cloud infrastructure." 
    },
    { 
      title: "Full-Stack System Modernization", 
      desc: "Migrated legacy systems to a modern MERN stack architecture (MongoDB, Express, React, Node.js) utilizing TypeScript and Tailwind CSS for enhanced performance and maintainability." 
    }
  ];

  return (
    <div className="min-h-screen pt-24 pb-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-slate-900 border border-slate-800 p-10 md:p-16 mb-12 shadow-lg animate-on-scroll opacity-0 translate-y-12 transition-all duration-[1000ms] ease-out">
          <div className="absolute inset-0 z-0">
            <img 
              src={PortfolioGraphic} 
              className="w-full h-full object-cover opacity-40 mix-blend-screen" 
              alt="Architectural Blueprint Background" 
            />
            <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-900/90 to-transparent"></div>
          </div>
          <div className="relative z-10 md:w-2/3">
            <p className="text-blue-500 text-xs uppercase tracking-[0.3em] font-bold mb-3">Selected Works</p>
            <h1 className="text-4xl md:text-5xl font-black text-white tracking-tighter mb-4">Portfolio</h1>
            <p className="text-slate-300 text-lg font-medium leading-relaxed max-w-2xl mt-4">
              A track record of delivering secure, high-performance digital transformations for enterprise clients and dynamic web platforms.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {projects.map((project, i) => (
            <div 
              key={i} 
              style={{ transitionDelay: `${i * 150}ms` }}
              className="animate-on-scroll opacity-0 translate-y-12 bg-slate-900/60 backdrop-blur-md border border-slate-800 p-8 md:p-10 rounded-2xl hover:bg-slate-800/80 hover:border-blue-500/50 hover:-translate-y-2 hover:shadow-[0_10px_30px_rgba(37,99,235,0.15)] transition-all duration-500 group cursor-default flex flex-col"
            >
              <div className="flex items-center justify-between mb-6">
                <span className="px-3 py-1 bg-blue-900/30 border border-blue-800/50 text-blue-400 text-[10px] uppercase tracking-widest font-bold rounded-full group-hover:bg-blue-600 group-hover:text-white group-hover:border-blue-500 transition-colors duration-300">
                  Case Study
                </span>
                <svg className="w-5 h-5 text-slate-600 group-hover:text-blue-400 transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
              </div>

              <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-blue-400 transition-colors duration-300 tracking-tight">
                {project.title}
              </h3>
              <p className="text-slate-400 text-base leading-relaxed group-hover:text-slate-300 transition-colors duration-300 flex-grow">
                {project.desc}
              </p>
              <div className="mt-8 h-[2px] w-8 bg-slate-700 group-hover:bg-blue-500 group-hover:w-full transition-all duration-700 ease-in-out"></div>
            </div>
          ))}
        </div>
        <div 
          className="animate-on-scroll opacity-0 translate-y-12 bg-slate-900/60 backdrop-blur-md border border-slate-800 rounded-2xl p-10 md:p-14 text-center shadow-lg relative overflow-hidden"
          style={{ transitionDelay: '300ms' }}
        >
          <div className="absolute top-0 left-1/2 w-64 h-64 bg-blue-600/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>
          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4 tracking-tight">Ready to start your project?</h2>
            <p className="text-slate-400 text-base mb-8 max-w-lg mx-auto leading-relaxed">
              Contact us today to discuss your vision and discover how we can engineer a solution tailored to your strategic goals.
            </p>
            <Link to="/contact" className="inline-block bg-blue-600 text-white px-10 py-4 rounded-lg font-bold hover:bg-blue-500 hover:shadow-[0_0_20px_rgba(37,99,235,0.4)] active:scale-95 transition-all duration-300 text-sm uppercase tracking-widest">
              Contact Us
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Portfolio;